import {gsap} from "../../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';
import {HarponTile} from "./HarponTile";

// Constructor
export class BearMaskHarponTile extends HarponTile {

  constructor(rowIndex, colIndex) {
    super(rowIndex, colIndex);

    this.type = "bear";

    this.build();

    this.hide();
  }

  build() {
    super.build();

    // NOTE: as we reuse the same texture, calling "play" animates ALL the bears
    // Important to know if we have more than one bear in the game
    this.testedTile = new PIXI.Sprite(app.game.assets["tile-ours-mask"]);
    // this.testedTile.texture.source.resource.pause();
    // this.testedTile.texture.source.resource.currentTime = 0;
    this.testedTile.position.set(-24, -81);
    this.testedTile.scale.set(0.95);
    this.testedTile.alpha = 1;
    this.addChild(this.testedTile);
  }

  show() {
    console.log("show mask");
    this.alpha = 1;
  }

  hide() {
    console.log("hide mask");
    this.alpha = 0;
  }

  // play() {
  //   this.testedTile.texture.source.resource.play();
  // }


}
